jQuery(document).ready(function () {
    resolve_all_checkbox();
    download_csv_all_issues();
    download_csv_single_issue();
    show_instances_on_click();
    delete_user_link_button();
});

// delete user link functionality for button on linked accounts page 
function delete_user_link_button() {
    let deleteButtons = document.querySelectorAll(`.delete-user-link`);

    
    if (typeof deleteButtons != 'undefined' && deleteButtons != null) {
        deleteButtons.forEach( button => {
            let user_id = button.getAttribute('data-delete-user-link')
            
            button.addEventListener('click', function () {
                // window.location.replace(payNowUrl)
                delete_user_link(user_id)
            })
        });

    }
}

function delete_user_link(user_id) { 
    jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
            action: "delete_user_link",
            user_id: user_id
        },
        success: function (response) {
            let parsed = JSON.parse(response);
            console.log(parsed);
            location.reload(); 
        },
        error: function (xhr, ajaxOptions, errorMessage) {
            console.log("ERROR:" + errorMessage);
        },
    });
}

function get_instances_by_code_id(reportId, codeId, limit) {
    jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
            action: "get_issues_by_code_id",
            report_id: reportId,
            code_id: codeId,
            limit: limit,
        },
        success: function (response) {
            let parsed = JSON.parse(response);
            console.log(parsed);
            display_instances(codeId, reportId, response);
        },
        error: function (xhr, ajaxOptions, errorMessage) {
            console.log("ERROR:" + errorMessage);
        },
    });
}

function show_instances_on_click() {
    let showInstances = document.querySelectorAll(".show-instances");

    if (typeof showInstances !== "undefined" && showInstances !== null) {
        showInstances.forEach((element) => {
            let codeId = element.dataset.codeId;
            let reportId = element.dataset.reportId;

            element.addEventListener("click", function () {
                let hidden = document.getElementById(
                    `hidden-instance-${codeId}`
                );
                document.getElementById("hidden-instance-" + codeId).classList.toggle("hidden");

                if (!hidden.classList.contains("hidden")) {
                    get_instances_by_code_id(reportId, codeId, 20);
                }
            });
        });
    }
}

function get_instances_by_code_id_csv(reportId, codeId) {
    return new Promise((resolve, reject) => {
        jQuery.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: "get_issues_by_code_id",
                report_id: reportId,
                code_id: codeId,
            },
            success: function (response) {
                let parsed = JSON.parse(response);
                resolve(parsed);
            },
            error: function (xhr, ajaxOptions, errorMessage) {
                console.log("ERROR:" + errorMessage);
                reject(errorMessage);
            },
        });
    });
}

function display_instances(codeId, reportId, data) {
    let section = document.getElementById("hidden-instance-" + codeId);
    let html = "";
    data = JSON.parse(data);

    data.forEach((d) => {
        let context = escapeHtml(d.context);
        let selector = escapeHtml(d.selector);
        html += `<div class='hidden-row`;
        if (d.is_fixed != "0") {
            html += " resolved ";
        }
        html += `' id='hidden-row-${d.issue_id}'><div class='hidden-column'> <input class='resolved-checkbox'`;
        if (d.is_fixed != "0") {
            html += " checked ";
        }
        // data-report-id="${d.report_id}"  data-code-id="${d.code_id}
        html += ` type="checkbox" id="issue-${d.issue_id}" name="issue-${d.issue_id}" value="${d.issue_id}" data-code-id="${d.code_id}">
                        <label for="issue-${d.issue_id}">Issue Resolved</label><br>
                        <a class='issue-page-url' href='${d.url}' target="_blank">${d.url}</a>
                    </div>
                    <div class='hidden-column expand'>
                        <a class='show-single-instance' id="show-instances-${d.issue_id}" data-code-id="${d.issue_id}"><svg class="icon"><use xlink:href="/wp-content/themes/oi-mastertheme/assets/images/svg/solid.svg#caret-down"></use></svg></a>
                    </div>
                </div>
                <div class='hidden issue-info-section' id='hidden-${d.issue_id}' data-issue-id='${d.issue_id}'>
                    <div class='issue-title'>Info</div>
                    <div>${d.message}</div>
                    <div class='copy-row'>
                        <div class='issue-title'>Context</div>
                        <div class='copy'>
                            <input disabled class='copy-input' type="text" value="${context}" id="copy-context-${d.issue_id}">
                            <a class='copy-button' id='copy-button-${d.issue_id}' data-issue-id='${d.issue_id}' data-specifier="context">Copy Context</a>
                        </div>
                    </div>
                    <div class='copy-row'>
                        <div class='issue-title'>Selector</div>
                        <div class='copy'>
                            <input disabled class='copy-input' type="text" value="${selector}" id="copy-selector-${d.issue_id}">
                            <a class='copy-button' id='copy-button-${d.issue_id}' data-issue-id='${d.issue_id}' data-specifier="selector">Copy Selector</a>
                        </div>
                    </div>
                </div>            
            `;
    });

    section.innerHTML = html;
    show_hide_single_instance_info();
    copy_content_to_clipboard();

    let checkboxes = document.querySelectorAll(".resolved-checkbox");

    checkboxes.forEach((box) => {
        let issueId = box.value;
        // let codeId = box.dataset.codeId
        // let reportId = box.dataset.reportId

        box.addEventListener("click", () => {
            console.log("clicked");
            box.closest(".hidden-row").classList.toggle("resolved");
            update_single_issue(issueId, codeId, reportId, box.checked);
        });
    });
}

function resolve_all_checkbox() {
    let resolveAllCheckboxes = document.querySelectorAll(".all-resolved-checkbox");

    // if (typeof showInstances !== "undefined" && showInstances !== null) {
        resolveAllCheckboxes.forEach((box) => {
            let reportId = box.value;
            let codeId = box.dataset.codeId;
            // let reportId = box.dataset.reportId

            box.addEventListener("click", () => {
                // console.log("clicked");
                // console.log(reportId);
                // console.log(codeId);
                // box.closest(".hidden-row").classList.toggle("resolved");
                update_all_issues(codeId, reportId, box.checked);
            });
        });
    // }
}

function update_all_issues(codeId, reportId, checked) {
    jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
            action: "update_all_issue_by_id",
            code_id: codeId,
            report_id: reportId,
            account_id: accountId,
            checked: checked,
        },
        success: function (response) {
            let parsed = JSON.parse(response);
            let singleData = parsed.single[0];
            let summaryData = parsed.all;
            let singleJSON = `[{"name": "completed", "value": "${singleData.fixed_count}"},{"name": "needs fixed", "value": "${singleData.not_fixed_count}"}]`;
            let palette = ["#003366", "#adc0d6"];
            let childID = `completion-donut-${codeId}`;
            let child = document.getElementById(childID);
            let parentID = child.parentNode.id;

            update_child_checkboxes(codeId, checked);
            generateDonutGraph(singleJSON, palette, parentID, childID, codeId);
            update_fixed_text(singleData, codeId);
            update_report_summary_graphs(summaryData);
            update_parent_issue_count(parsed.all)
        },
        error: function (xhr, ajaxOptions, errorMessage) {
            console.log("ERROR:" + errorMessage);
        },
    });
}

function update_parent_issue_count(parsed) {
    console.log(typeof parsed)
    console.log(parsed)
    parsed.forEach((item) => {
        console.log(item.level)
        if (item.level === "WCAG2A") {
            document.getElementById('a-error-text').innerText = Number(item.not_fixed_count).toLocaleString()
        } else if (item.level === "WCAG2AA") {
            document.getElementById('aa-error-text').innerText = Number(item.not_fixed_count).toLocaleString()
        } else if (item.level === "WCAG2AAA") {
            document.getElementById('aaa-error-text').innerText = Number(item.not_fixed_count).toLocaleString()
            
        }
    })
}

function update_child_checkboxes(codeId, checked) {
    let checkboxes = document.querySelectorAll(`.resolved-checkbox[data-code-id='${codeId}']`);
    
    // console.log(checkboxes);
    checkboxes.forEach((box) => {
        if (checked == true) {
            box.checked = true;
            console.log("box check = true");
            box.closest(".hidden-row").classList.add("resolved");
        } else {
            box.checked = false;
            box.closest(".hidden-row").classList.remove("resolved");
        }
    });
}

function update_single_issue(issueId, codeId, reportId, checked) {
    jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
            action: "update_single_issue_by_id",
            issue_id: issueId,
            code_id: codeId,
            report_id: reportId,
            account_id: accountId,
            checked: checked,
        },
        success: function (response) {
            let parsed = JSON.parse(response);
            console.log(parsed);
            console.log(parsed.single[0]);
            let singleData = parsed.single[0];
            let summaryData = parsed.all;
            let singleJSON = `[{"name": "completed", "value": "${singleData.fixed_count}"},{"name": "needs fixed", "value": "${singleData.not_fixed_count}"}]`;
            let palette = ["#003366", "#B6CADF"];
            let childID = `completion-donut-${codeId}`;
            let child = document.getElementById(childID);
            let parentID = child.parentNode.id;
            generateDonutGraph(singleJSON, palette, parentID, childID, codeId);
            update_fixed_text(singleData, codeId);
            update_report_summary_graphs(summaryData);
        },
        error: function (xhr, ajaxOptions, errorMessage) {
            console.log("ERROR:" + errorMessage);
        },
    });
}

function update_report_summary_graphs(data) {
    let singleAPalette = ["#A80000", "#EDB6B6"];
    let doubleAPalette = ["#003366", "#B6CADF"];
    let tripleAPalette = ["#006600", "#B6DFB6"];

    data.forEach((d) => {
        if (d.level == "WCAG2A") {
            let JSON = `[{"name":"completed","value":"${d.fixed_count}"},{"name":"needs fixed","value":"${d.not_fixed_count}"}]`;
            generateDonutGraph(
                JSON,
                singleAPalette,
                "a-errors",
                "a-error-text",
                "a-errors"
            );
        } else if (d.level == "WCAG2AA") {
            let JSON = `[{"name":"completed","value":"${d.fixed_count}"},{"name":"needs fixed","value":"${d.not_fixed_count}"}]`;
            generateDonutGraph(
                JSON,
                doubleAPalette,
                "aa-errors",
                "aa-error-text",
                "aa-errors"
            );
        } else if (d.level == "WCAG2AAA") {
            let JSON = `[{"name":"completed","value":"${d.fixed_count}"},{"name":"needs fixed","value":"${d.not_fixed_count}"}]`;
            generateDonutGraph(
                JSON,
                tripleAPalette,
                "aaa-errors",
                "aaa-error-text",
                "aaa-errors"
            );
        }
    });
}

function update_fixed_text(data, codeId) {
    let ratio = document.getElementById(`fixed-ratio-${codeId}`);
    let percentText = document.getElementById(`fixed-percent-${codeId}`);
    let percent = ((data.fixed_count / data.issue_count) * 100).toFixed(2);

    percentText.innerHTML = percent + "%";
    ratio.innerHTML = `${Number(data.fixed_count).toLocaleString()}/${Number(data.issue_count).toLocaleString()} Fixed`;
}

function copy_content_to_clipboard() {
    let copyButtons = document.querySelectorAll(".copy-button");

    copyButtons.forEach((button) => {
        let issueId = button.dataset.issueId;
        let specifier = button.dataset.specifier;

        button.addEventListener("click", () => {
            let input = document.getElementById(`copy-${specifier}-${issueId}`);

            input.select();
            input.setSelectionRange(0, 9999); // for Mobile devices
            navigator.clipboard.writeText(input.value);

            button.innerText = "Copied!";
            setTimeout(() => {
                button.innerText = `Copy ${specifier}`;
            }, 2000);
        });
    });
}

function show_hide_single_instance_info() {
    let showSingleInstances = document.querySelectorAll(
        ".show-single-instance"
    );

    showSingleInstances.forEach((element) => {
        let codeId = element.dataset.codeId;
        element.addEventListener("click", () => {
            let e = document.getElementById("hidden-" + codeId);
            e.classList.toggle("hidden");
        });
    });
}

function download_csv_all_issues() {
    let downloadAll = document.getElementById("download-all-csv");

    if (typeof downloadAll !== "undefined" && downloadAll !== null) {
        let reportId = downloadAll.dataset.reportId;

        downloadAll.addEventListener("click", function () {
            // downloadAll.style.pointerEvents="none";
            // downloadAll.style.cursor="not-allowed";
            downloadAll.disabled = true;
            downloadAll.innerHTML = "<span class='spinner'></span> DOWNLOADING!";

            get_all_errors_csv(reportId)
                .then((parsed) => {
                    download_csv(parsed, "ada_report_" + reportId);
                    downloadAll.innerText = "DOWNLOAD REPORT";
                    downloadAll.disabled = false;
                    // downloadAll.style.pointerEvents="auto";
                    // downloadAll.style.cursor="pointer";
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }
}

function get_all_errors_csv(reportId) {
    return new Promise((resolve, reject) => {
        jQuery.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: "get_all_errors_csv",
                report_id: reportId,
            },
            success: function (response) {
                let parsed = JSON.parse(response);
                resolve(parsed);
            },
            error: function (xhr, ajaxOptions, errorMessage) {
                console.log("ERROR:" + errorMessage);
                reject(errorMessage);
            },
        });
    });
}

function download_csv_single_issue() {
    let singleDownload = document.querySelectorAll(".download-issue-csv");

    if (typeof singleDownload !== "undefined" && singleDownload !== null) {
        singleDownload.forEach((element) => {
            let reportId = element.dataset.reportId;
            let codeId = element.dataset.codeId;

            element.addEventListener("click", () => {
                element.disabled = true;
                element.innerHTML = "<span class='spinner'></span> DOWNLOADING!";
                
                get_instances_by_code_id_csv(reportId, codeId)
                    .then((parsed) => {
                        download_csv(
                            parsed,
                            `ada_report_${reportId}_issue_${codeId}`
                        );
                        element.innerText = "Download CSV";
                        element.disabled = false;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            });
        });
    }
}

function download_csv(data, fileName) {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    let blob = new Blob([csv_data(data)], { type: "text/csv;charset=utf-8" });
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
}

function csv_data(data) {
    try {
        if (data && data.length) {
            const headers = Object.keys(data[0]);
            let csvRows = [];
            let quotedHeaders = headers.map(function (h) {
                return '"' + h + '"';
            });
            csvRows.push(quotedHeaders.join(","));

            for (const row of data) {
                const values = headers.map(function (h) {
                    if (typeof row[h] === "string") {
                        return '"' + row[h].replace(/"/g, '""') + '"'; // escape any " with ""
                    }
                    return '"' + row[h] + '"';
                });
                csvRows.push(values.join(","));
            }

            let datastring = csvRows.join("\n");
            // console.log(datastring);
            // console.log("csv data length: " + datastring.length);

            return datastring;
        } else {
            console.log("no data");
        }
    } catch (err) {
        console.error("ERROR");
        console.error(err);
        return "";
    }
}

function escapeHtml(html) {
    return html
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}
// function getFranchise__c() {
//     jQuery.ajax({
//         type: 'POST',
//         url: '/wp-admin/admin-ajax.php',
//         data: {
//             action: 'get_errors_by_page_level1'
//         },
//         success: function (response) {
//             let parsed = JSON.parse(response);
//         },
//         error: function (xhr, ajaxOptions, errorMessage) {
//             console.log('ERROR:' + errorMessage)
//         }
//     })
// }
